import { useEffect } from 'react';

const TOKEN_KEY = 'user_token';
const REDUX_KEY = 'persist:root';
const FLOOP_KEY = 'showFloop';

/**
 * Set `localStorage` variables for domain continuity between SPAs (trinity, pets, etc.)
 *
 * Required for navigating to /pets/* & /v3/tenant-applications/*
 */
export function useSetJWTLocalStorage(jwt: string | undefined) {
  useEffect(() => {
    const jwtString = jwt ? `JWT ${jwt}` : '';
    const userToken = localStorage.getItem(TOKEN_KEY);
    const reduxBlob = localStorage.getItem(REDUX_KEY);

    const shouldBePresent = jwt !== undefined;

    const fullyPresent =
      userToken &&
      userToken === jwtString &&
      reduxBlob?.includes('"isLoggedIn\\":true');

    const somewhatPresent =
      userToken || reduxBlob?.includes('"isLoggedIn\\":true');

    if (
      (shouldBePresent && !fullyPresent) ||
      (!shouldBePresent && somewhatPresent)
    ) {
      if (jwt === undefined) {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(REDUX_KEY);
      } else {
        localStorage.setItem(TOKEN_KEY, jwtString);
        localStorage.setItem(REDUX_KEY, '{"user":"{\\"isLoggedIn\\":true}"}');
      }
    }

    const hasFloop = localStorage.getItem(FLOOP_KEY);
    if (!hasFloop) {
      localStorage.setItem(FLOOP_KEY, 'true');
    }
  }, [jwt]);
}
